import es from "./es";
import en from "./en";

const DICTS = { es, en };
let current = es;

// Cambia el diccionario activo. Se llama de forma síncrona durante el render
// de StudioProvider (antes de que los hijos lean `t`), para que el cambio de
// idioma sea reactivo sin tener que reescribir cada componente.
export const setLanguage = (lang) => {
  current = DICTS[lang] || es;
};

// Proxy de un solo nivel: `t.seccion` siempre devuelve el objeto de la sección
// del diccionario activo en ese momento. Evitar desestructurar `t.seccion.campo`
// a nivel de módulo (fuera de un componente/función), porque fijaría el idioma
// inicial para siempre.
export const t = new Proxy({}, {
  get(_target, prop) {
    return current[prop];
  },
});

export const LANGUAGES = [
  { code: "es", label: "Español", enabled: true },
  { code: "en", label: "English", enabled: true },
];
